import { MenuItem } from 'element-ui'

const YMenuItem = MenuItem
YMenuItem.$depends = [MenuItem]
YMenuItem.$name = 'y-menu-item'
YMenuItem._name = 'MenuItem 导航菜单选项'

export default YMenuItem
